import { TYPES } from "./default_bank.type";

const initState = {
  defaultBankAll: null,
  defaultBankOpenAdd: false,
  defaultBankOpenEdit: false,
  defaultBankSelected: null,
  defaultBankSearch: "",
  //
  defaultBankLast: null,
};

const defaultBankReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DEFAULT_BANK_ALL:
      return {
        ...state,
        defaultBankAll: payload,
      };

    case TYPES.SET_DEFAULT_BANK_OPEN_ADD:
      return {
        ...state,
        defaultBankOpenAdd: payload,
      };

    case TYPES.SET_DEFAULT_BANK_OPEN_EDIT:
      return {
        ...state,
        defaultBankOpenEdit: payload,
      };

    case TYPES.SET_DEFAULT_BANK_SELECTED:
      return {
        ...state,
        defaultBankSelected: payload,
      };

    case TYPES.SET_DEFAULT_BANK_SEARCH:
      return {
        ...state,
        defaultBankSearch: payload,
      };

    case TYPES.SET_DEFAULT_BANK_LAST:
      return {
        ...state,
        defaultBankLast: payload,
      };

    default:
      return state;
  }
};

export default defaultBankReducer;
